import {take} from 'redux-saga/effects';
import updateServiceCase from '../../service-cases/sagas/updateServiceCase';
import * as serviceCaseActionTypes from '../../service-cases/serviceCaseActionTypes';

/**
 * Update service assignment final destination flow
 */
const updateServiceAssignmentFinalDestination = function* updateServiceAssignmentFinalDestination() {
    while (true) {
        const {payload} = yield take([
            serviceCaseActionTypes.INITIATE_SERVICE_CASE_FINAL_DESTINATION_UPDATE_FLOW,
        ]);
        const {serviceCaseId, caseType, serviceCaseData} = payload;

        yield* updateServiceCase({
            caller: serviceCaseActionTypes.INITIATE_SERVICE_CASE_FINAL_DESTINATION_UPDATE_FLOW,
            caseType,
            serviceCaseId,
            serviceCaseData,
        });
    }
};

export default updateServiceAssignmentFinalDestination;
